// Easily updatable content sources — swap titles/links/thumbs as new content drops.

export const VIDEOS = [
  {
    id: "v1",
    title: "EP. 47 — The Detroit Renaissance Is Now",
    tag: "LONG-FORM",
    duration: "1:12:40",
    thumb: "https://images.unsplash.com/photo-1593098392687-f88e61aaf585?crop=entropy&cs=srgb&fm=jpg&q=85",
  },
  {
    id: "v2",
    title: "INTERVIEW — From the Eastside to the Industry",
    tag: "INTERVIEW",
    duration: "48:12",
    thumb: "https://images.unsplash.com/photo-1737307413700-b8660fad4c63?crop=entropy&cs=srgb&fm=jpg&q=85",
  },
  {
    id: "v3",
    title: "SHORTS — Culture in 60 Seconds",
    tag: "SHORTS",
    duration: "0:58",
    thumb: "https://images.unsplash.com/photo-1618066782082-b1ed08561aa1?crop=entropy&cs=srgb&fm=jpg&q=85",
  },
  {
    id: "v4",
    title: "CLIPS — Best of the Report, Vol. 3",
    tag: "CLIPS",
    duration: "12:05",
    thumb: "https://images.unsplash.com/photo-1530138542-396a2e2c2330?crop=entropy&cs=srgb&fm=jpg&q=85",
  },
];

export const TRACKS = [
  {
    id: "t1",
    title: "Motor City Nights",
    artist: "Cobain Selects",
    time: "3:42",
    art: "https://images.unsplash.com/photo-1642522843063-5d254aca2a24?crop=entropy&cs=srgb&fm=jpg&q=85",
  },
  {
    id: "t2",
    title: "Tan Leather Seasons",
    artist: "The Report Presents",
    time: "4:05",
    art: "https://images.unsplash.com/photo-1648738673511-16dd92b30d3b?crop=entropy&cs=srgb&fm=jpg&q=85",
  },
  {
    id: "t3",
    title: "Wood Grain Frequency",
    artist: "Detroit Circuit",
    time: "2:58",
    art: "https://images.unsplash.com/photo-1636788358412-4e5342dad7ab?crop=entropy&cs=srgb&fm=jpg&q=85",
  },
  {
    id: "t4",
    title: "Gold Hour Anthem",
    artist: "Cobain Selects",
    time: "3:21",
    art: "https://images.unsplash.com/photo-1789559638089-939a20c9931e?crop=entropy&cs=srgb&fm=jpg&q=85",
  },
];

export const MARQUEE_ITEMS = [
  "DETROIT CULTURE",
  "THE COBAIN REPORT",
  "HEAR IT HERE FIRST",
  "LEGENDARY IN THE MAKING",
  "BIGGER THAN A PODCAST",
  "FOR THE CULTURE",
];

// Budget tiers for the Get Featured glider — recommendation rules, not finalized pricing.
// Edit thresholds/copy here; the form and emails pick changes up automatically.
export const BUDGET_TIERS = [
  { display: "Under $50", message: "Custom affiliation opportunities through the website or social media." },
  { display: "$50 – $99", message: "Introductory promotional and affiliation opportunities." },
  { display: "$100 – $199", message: "Explore interview, editorial, and music promotion opportunities." },
  { display: "$200 – $349", message: "Explore broader editorial and digital visibility opportunities." },
  { display: "$350 – $599", message: "Explore combinations of media placements." },
  { display: "$600 – $999", message: "Explore broader campaign possibilities." },
  { display: "$1,000+", message: "Let's build a custom campaign around your goals — the full Cobain conversation." },
];

export const NAV_LINKS = [
  { id: "watch", label: "WATCH" },
  { id: "latest", label: "LATEST" },
  { id: "music", label: "MUSIC" },
  { id: "streaming", label: "STREAM" },
  { id: "read", label: "READ" },
  { id: "shop", label: "SHOP" },
  { id: "get-featured", label: "GET FEATURED" },
];
